import { render, staticRenderFns } from "./mirrorReality.vue?vue&type=template&id=6787ce00&scoped=true&"
import script from "./mirrorReality.vue?vue&type=script&lang=js&"
export * from "./mirrorReality.vue?vue&type=script&lang=js&"
import style0 from "./mirrorReality.vue?vue&type=style&index=0&id=6787ce00&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6787ce00",
  null
  
)

export default component.exports